var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('div',{staticClass:"cwrap cwrap--phase-program marginbottom--micro"},_vm._l((_vm.phases),function(phase){return _c('ProgramPhase',{key:phase.id,attrs:{"phase":phase,"showManual":_vm.showManual},on:{"dismissManual":function($event){_vm.showManual = false}}})}),1),(_vm.phases.length && _vm.hasArea)?_c('ProgramTables'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }